import { getApplicationUrl } from 'service/env'

const MODULE_PATHS = {
  privacy_by_design: 'privacy-by-design',
  ai_inventory: 'ai-inventory',
}

const buildJourneyUrl = (
  token,
  organizationSlug = 'dponet',
  module = 'privacy_by_design',
) => {
  const modulePath = MODULE_PATHS[module] || module
  return `${getApplicationUrl()}/${organizationSlug}/guests/${token}/${modulePath}`
}

export default buildJourneyUrl
